import * as Rx from 'rxjs/Rx'
import * as uuid from 'uuid'
import { ActionsObservable, combineEpics } from 'redux-observable'
import { AnyAction } from 'typescript-fsa'
import { Store } from 'redux'

import Dependencies from '../Dependencies'
import Epic from '../Epic'
import State from '../../states'
import { SpeakEvent } from '../../io/events'
import { World } from '../../actions'

// Post message for current player
const postMessage = (
  action$: ActionsObservable<AnyAction>,
  store: Store<State>,
  { apiClient }: Dependencies
) =>
  action$.filter(World.postMessage.match).mergeMap(action => {
    const message = action.payload
    if (!message.trim().length) {
      return Rx.Observable.empty()
    }
    const player = store.getState().world.player!
    const now = new Date().getTime()
    const localID = 'EV' + uuid()

    const localEvent: SpeakEvent = {
      id: localID,
      type: 'speak',
      mapObjectID: player.id,
      name: player.displayName,
      createdAt: now,
      local: true,
      bySelf: false,
      localID,
      message
    }
    return Rx.Observable.of(World.localEventUpdate(localEvent)).concat(
      apiClient
        .postMessage({
          id: player.id,
          message,
          localID
        })
        .ignoreElements()
    )
  })

export default combineEpics<Epic>(postMessage)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/world/dialogue.ts